import dynamic from 'next/dynamic'

const LoadingComponent = () => <div>...</div>

const ReactMarkdown = dynamic(() => import('react-markdown').then(mod => mod.default), {
    ssr: true,
    loading: LoadingComponent,
})

interface DynamicMarkdownProps {
    children: string
    [key: string]: any
}

export default function DynamicMarkdown({ children, className, ...props }: DynamicMarkdownProps) {
    return (
        <div className={className}>
            <ReactMarkdown {...props}>{children}</ReactMarkdown>
        </div>
    )
}
